import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DripCampaignActiveToggle from "./drip-campaign-active-toggle";
import ButtonBar from "@Shared/components/general/button-bar";
import RefreshableTimeago from "@Shared/components/general/refreshable-timeago";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignTable",
  components: {
    DripCampaignActiveToggle,
    ButtonBar,
    RefreshableTimeago,
    ProfileAvatar
  },
  filters: {
    dripCampaignEditLink(id) {
      return {
        path: `/automation/drip-campaigns/${id}`
      };
    }
  },
  props: {
    campaigns: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      columns: ["name", "active", "numOfEmails", "numOfClients", "actions"],
      options: {
        filterable: false,
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        perPage: 99999,
        tabbable: false,
        columnsClasses: {
          fullname: "w-25",
          email: "w-30"
        },
        skin: "table table-hover",
        customFilters: [{
          name: "name",
          callback: (row, query) => {
            var _context;
            const searchString = `${row.name}`;
            return _indexOfInstanceProperty(_context = searchString.toLowerCase()).call(_context, query.toLowerCase()) >= 0;
          }
        }],
        texts: {
          noResults: this.$t("tables.messages.emptyDripCampaigns")
        }
      }
    };
  },
  methods: {
    handleShowClients(id) {
      this.$emit("show-clients", id);
    }
  }
});